import React from "react";
import { useTranslation } from "react-i18next";

import { Toolbar, Box, styled } from "@mui/material";

import { Header } from "./Header";
import { Drawer } from "./Drawer";
import { Main } from "./Main";

import { DrawerContextProvider } from "../contexts/drawer-context";
import { Outlet } from "react-router-dom";
import FileInfoManager from "./FileInfo/FileInfoManager";

const OuterContainer = styled(Box)`
  display: flex;
  overflow: hidden;
  height: inherit;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
`;

const InnerContainer = styled(Box)`
  display: flex;
  flex: 1;
  overflow: hidden;
  height: inherit;
  gap: 0;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

// interface ILayoutProps {
//   children: NonNullable<ReactNode>;
// }

export const FLayout = () => {
  const { t } = useTranslation();
  console.log('FLayout component loaded');
  return (
    <DrawerContextProvider>
      {/* 使用BFF标准做法：在认证路由内部管理文件信息 */}
      <FileInfoManager />
      <OuterContainer>
        <Header />
        <Toolbar />
        <InnerContainer>
          <Drawer />
          <Main><Outlet /></Main>
        </InnerContainer>
      </OuterContainer>
    </DrawerContextProvider>
  );
};
